import type { ReactNode } from 'react'

export type IconName = 'shield' | 'user' | 'key' | 'bot' | 'database' | 'apps' | 'check' | 'arrow' | 'play' | 'pause' | 'replay' | 'code' | 'link' | 'globe'

export function ExperienceIcon({ name, size = 20 }: { name: IconName; size?: number }) {
  const paths: Record<IconName, ReactNode> = {
    shield: <><path d="M12 3 4.5 6v5c0 4.7 3.1 8.2 7.5 10 4.4-1.8 7.5-5.3 7.5-10V6L12 3Z" /><path d="m8.5 12 2.3 2.3 4.7-4.7" /></>,
    user: <><circle cx="12" cy="8" r="3.5" /><path d="M5 21v-2a7 7 0 0 1 14 0v2" /></>,
    key: <><circle cx="8" cy="9" r="5" /><path d="m12 12 8 8m-3-3 3-3m-6 0 3-3" /></>,
    bot: <><rect x="4" y="7" width="16" height="13" rx="4" /><path d="M12 3v4M1 12v4m22-4v4M8 12v2m8-2v2m-7 3h6" /></>,
    database: <><ellipse cx="12" cy="5" rx="8" ry="3" /><path d="M4 5v14c0 4 16 4 16 0V5M4 12c0 4 16 4 16 0" /></>,
    apps: <>{[3, 14].flatMap(x => [3, 14].map(y => <rect key={`${x}-${y}`} x={x} y={y} width="7" height="7" rx="1.5" />))}</>,
    check: <path d="m5 12 4 4L19 6" />,
    arrow: <path d="M4 12h15m-6-6 6 6-6 6" />,
    play: <path d="m9 5 10 7-10 7V5Z" />,
    pause: <><path d="M8 5v14M16 5v14" /></>,
    replay: <><path d="M4 10a8 8 0 1 1 .5 6M4 4v6h6" /></>,
    code: <><path d="m8 6-6 6 6 6m8-12 6 6-6 6m-3-15-2 18" /></>,
    link: <><path d="m9 15 6-6M8 16l-1 1a4 4 0 0 1-6-6l5-5a4 4 0 0 1 6 0m0 12a4 4 0 0 0 6 0l5-5a4 4 0 0 0-6-6l-1 1" transform="translate(1 0) scale(.92)" /></>,
    globe: <><circle cx="12" cy="12" r="9" /><ellipse cx="12" cy="12" rx="4" ry="9" /><path d="M3 12h18" /></>,
  }
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>{paths[name]}</svg>
}

